import { render } from "./ConnectionRow.vue?vue&type=template&id=65971a47&scoped=true&ts=true"
import script from "./ConnectionRow.vue?vue&type=script&lang=ts"
export * from "./ConnectionRow.vue?vue&type=script&lang=ts"

import "./ConnectionRow.vue?vue&type=style&index=0&id=65971a47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65971a47"]])

export default __exports__